<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load" :placeholder="$t('keyword')" />
          <form-select class="mr-1 mb-1" :model="filterFormModel" :options="statusOptions" @change="load" attribute="status"></form-select>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="() => {reset(); load()}" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-4">{{ $t('customerInfo') }}</div>
          <div class="col-lg-4">{{ $t('campaignContactFields') }}</div>
          <div class="col-lg-4">{{ $t('status') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-4">
            <div><b>{{ $t('phone') }}:&nbsp;</b><span>{{ item.phone }}</span></div>
            <div v-if="item.name"><b>{{ $t('name') }}:&nbsp;</b><span>{{ item.name }}</span></div>
            <div v-if="item.desc"><b>{{ $t('desc') }}:&nbsp;</b><span>{{ item.desc }}</span></div>
          </div>
          <div class="col-lg-4">
            <div v-if="campaign.contactCustomFields && item.customFields">
                <span v-for="f in item.customFields" v-bind:key="f.key">
                    <p v-for="c in campaign.contactCustomFields" v-bind:key="c._id">
                        <span v-if="!c.isOutputData && c.key === f.key">
                            <b>{{ c.label }}:</b>
                            {{getCustomFieldValue(f)}}
                        </span>
                    </p>
                </span>
            </div>
          </div>
          <div class="col-lg-4">
            <div v-if="campaign.type == 'viber' && item.contentViber">
              <b>{{ $t('content') }}:&nbsp;</b>
              <span>{{ item.contentViber }}</span>
            </div>
            <div v-else-if="item.content">
              <b>{{ $t('content') }}:&nbsp;</b>
              <span>{{ item.content }}</span>
            </div>
            <div>
              <b>{{ $t('createTime') }}:&nbsp;</b>
              <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.updateTime">
              <b>{{ $t('updateTime') }}:&nbsp;</b>
              <span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="campaign.type == 'viber' && item.viber && item.viber.confirmTime">
              <b>{{ $t('confirmTime') }}:&nbsp;</b>
              <span>{{ item.viber.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.sendTime">
              <b>{{ $t('sendTime') }}:&nbsp;</b>
              <span>{{ item.sendTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div>
              <b v-if="campaign.isAgainTwo || campaign.isAgainThree" >{{ $t('1st') }} {{ $t(campaign.type) }}:&nbsp;</b>
              <label v-if="!item.sendTime && !campaign.startTime" class="badge badge-primary">{{ $t('notYetSend') }}</label>
              <label v-else-if="!item.sendTime" class="badge badge-warning">{{ $t('sending') }}</label>
              <label v-else-if="item.error" class="badge badge-danger">{{ $t('submitError') }}</label>
              <label v-else class="badge badge-success">{{ $t('sentSuccess')}} </label>

              <span v-if="item[campaign.type] && item[campaign.type].sendErrorMsg" class="text-gray-999 small ml-1">
                  {{ $t(campaign.type) }} {{ item[campaign.type].sendErrorMsg }}
                </span>
              <span v-else-if="item.errorMsg" class="text-gray-999 small ml-1">{{item.errorMsg}}</span>
            </div>
            <div v-if="item.sendTimeTwo">
              <b>{{ $t('sendTimeTwo') }}:&nbsp;</b>
              <span>{{ item.sendTimeTwo | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="campaign.isAgainTwo && item.error">
              <b>{{ $t('2nd') }} {{ $t(campaign.typeTwo) }}:&nbsp;</b>
              <label v-if="!item.sendTimeTwo && !campaign.startTime" class="badge badge-primary">{{ $t('notYetSend') }}</label>
              <label v-else-if="!item.sendTimeTwo" class="badge badge-warning">{{ $t('sending') }}</label>
              <label v-else-if="item.errorTwo" class="badge badge-danger">{{ $t('submitError') }}</label>
              <label v-else class="badge badge-success">{{ $t('sentSuccess')}} </label>

              <span v-if="item[campaign.typeTwo] && item[campaign.typeTwo].sendErrorMsg" class="text-gray-999 small ml-1">
                   {{ item[campaign.typeTwo].sendErrorMsg }}
                </span>
              <span v-else-if="item.errorMsgTwo" class="text-gray-999 small ml-1">{{item.errorMsgTwo}}</span>
            </div>
            <div v-if="item.sendTimeThree">
              <b>{{ $t('sendTimeThree') }}:&nbsp;</b>
              <span>{{ item.sendTimeThree | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="campaign.isAgainThree && item.errorTwo">
              <b>{{ $t('3rd') }} {{ $t(campaign.typeThree) }}:&nbsp;</b>
              <label v-if="!item.sendTimeThree && !campaign.startTime" class="badge badge-primary">{{ $t('notYetSend') }}</label>
              <label v-else-if="!item.sendTimeThree" class="badge badge-warning">{{ $t('sending') }}</label>
              <label v-else-if="item.errorThree" class="badge badge-danger">{{ $t('submitError') }}</label>
              <label v-else class="badge badge-success">{{ $t('sentSuccess')}} </label>

              <span v-if="item[campaign.typeThree] && item[campaign.typeThree].sendErrorMsg" class="text-gray-999 small ml-1">
                   {{ item[campaign.typeThree].sendErrorMsg }}
                </span>
              <span v-else-if="item.errorMsgThree" class="text-gray-999 small ml-1">{{item.errorMsgThree}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>

    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import moment from 'moment';

export default {
  components: {},
  props: ['campaign'],
  mixins: [List, CRUD],
  data() {
    return {
      autoLoad: true,
      service: 'message-campaign-contact/' + this.campaign._id,
      afterLoad: function () {
        this.items.forEach(item => {
          if (item.dials) {
            item.dials.reverse();
          }
        })
      },
      defaultFilterFormModel: {
        campaign: this.campaign._id,
        statusType: 'dial',
        keyword: '',
        status: null,
      },
      statusOptions: [
        {value: null, text: this.$t('all')},
        {value: 'sending', text: this.$t('sending')},
        {value: 'success', text: this.$t('success')},
        ...(this.campaign.isAgainTwo ? [
          {value: 'successOne', text: this.$t('successOne')},
          {value: 'successTwo', text: this.$t('successTwo')},
        ] : []),
        ...(this.campaign.isAgainThree ? [
          {value: 'successThree', text: this.$t('successThree')},
        ] : []),
        {value: 'error', text: this.$t('submitError')}
      ],
    }
  },
  i18n: {
    messages: {
      en: {
        contactList: "Contact list",
        sendTime: "Sent at",
        customerInfo: "Customer info",
        campaignContactFields: "Contact info",
        submitError: "Submit error",
        sentSuccess: "Sent success"
      },
      vi: {
        contactList: "Danh sách liên hệ",
        sendTime: "Gửi lúc lúc",
        customerInfo: "Thông tin khách hàng",
        campaignContactFields: "Thông tin liên hệ",
        submitError: "Gửi không thành công",
        sentSuccess: "Gửi thành công",
        sending: "Đang gửi",
        notYetSend: "Chưa gửi",
      }
    }
  },
  methods: {
    show() {
      this.showList = true;
      this.load();
    },
    getCustomFieldValue: function (f) {
      let items = [];
      if (this.campaign.contactCustomFields) {
        items = this.campaign.contactCustomFields.filter(field => field.key === f.key);
      }
      if (items.length > 0) {
        let customField = items[0];
        let context = f.val && f.val.length === 1 ? f.val[0] : f.val.join(", ");
        if(customField.inputType === 'number') {
          context = new Intl.NumberFormat().format(context);
        } else if(customField.inputType === 'date') {
          context = moment(Number(context)).format('DD/MM/YYYY HH:mm:ss');
        }
        return context;
      } else {
        return "";
      }
    },
  }
}
</script>
<style>
.modal-content-2 {
  background-color: #e5e5e5;
}
</style>
